import ApiService from './api.service'

const PowCustomerService = {

  /***
   * Get customer by id
   * @param {string} slug customer id of the customer to find
   * @returns {*}
   */
  get (slug) {
    return ApiService.query(`pow-customer/${slug}`)
  },
  /***
   * Query pow/plat database for customer records
   * @param {string} params.query string to search the database for
   * @param {boolean} params.force flag to use redis cache for result
   * @returns {*}
   */
  searchCustomers (params) {
    return ApiService.post('pow-customer/search', params)
  },
  /***
   * Move services from one customer rate to another
   * @param {number} params.data_id id of the row to update
   * @param {number} params.svc_type enum for the service type to move
   * @param {number} params.cust_id number of the customer we want to move the service to
   * @param {number} params.crid id of the custrate to move service to
   * @returns {*}
   */
  moveService (params) {
    return ApiService.post('pow-customer/move-service', params)
  },
  /***
   * Query services to display APs in range
   * @param {string} params.format return data in defined format json/csv
   * @param {string} params.query string
   * @param {object} params.filters object containing all the filters we want to use
   * @param {object} params.filters.towerNumber object containing value array of tower number strings
   * @param {object} params.filters.apType object containing value array of apType strings
   * @param {object} params.filters.radius object containing value array of radius group strings
   * @returns {*}
   * @returns {*}
   */
  mapServices (params) {
    return ApiService.post('pow-customer/map-services', params)
  },
  /***
   * Query pow/plat database for customer records
   * @param {string} params.query string to search the database for
   * @param {boolean} params.force flag to use redis cache for result
   * @returns {*}
   */
  searchV2 (params) {
    return ApiService.query('pow-customer/search-v2', params)
  },

}
export default PowCustomerService
